import React from 'react';
import SvgIconContainer from '../SvgIconContainer';

export default function IconDiscountTag(props) {
  return (
    <SvgIconContainer {...props}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="currentColor"
        fillRule="nonzero"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.77759 0H12.4441C13.3033 0 13.9997 0.696429 13.9997 1.55552V6.22207C13.9997 6.81933 13.7719 7.41664 13.3163 7.87233L7.87194 13.3166C6.96074 14.2278 5.4834 14.2278 4.5722 13.3166L0.683401 9.42784C-0.227801 8.51662 -0.227801 7.03927 0.683401 6.12807L6.12772 0.683752C6.58332 0.228156 7.18043 0 7.77759 0ZM10.1109 5.44432C10.97 5.44432 11.6664 4.74789 11.6664 3.8888C11.6664 3.02971 10.97 2.33328 10.1109 2.33328C9.25176 2.33328 8.55535 3.02971 8.55535 3.8888C8.55535 4.74789 9.25176 5.44432 10.1109 5.44432Z" />
      </svg>
    </SvgIconContainer>
  );
}

IconDiscountTag.propTypes = SvgIconContainer.propTypes;
